<template>
  <div class="payment-amount container-fluid background-color-bank kanit pt-3">
    <div class="notification-payment">
        <span>
            หลังจากชำระเงินแล้วกรุณาส่งหลักฐานการชำระเงินมาที่แชทไม่เช่นนั้นพัสดุของคุณจะไม่ถูกจัดส่ง
        </span>
    </div>
    <div class="d-flex justify-content-between pt-3 container-fluid">
        <p>ยอดเงินที่ต้องชำระ</p>
        <h1 class="text-line-primary">฿{{ formattedTotal(total) }}</h1>
    </div>
    <div class="background-color-bank">
        <div v-if="isPrompay && total <= 5000">
            <div class="p-4 d-flex justify-content-center">
                <img :src="linkURL" class="w-20" />
            </div>
            <div class="d-flex justify-content-center">
                <b-button class="borderbox ml-3 non-boxshadow" @click="downloadImage(linkURL)">
                    <img src="../../assets/icon/saveqr.png" alt="">
                    <span class="font-16px">
                        บันทึก QR
                    </span>
                </b-button>
                <b-button class="borderbox ml-3 non-boxshadow" @click="sharingQR(linkURL)">
                    <img src="../../assets/icon/share.png" alt="">
                    <span class="font-16px">
                        แชร์ QR
                    </span>
                </b-button>
            </div>
        </div>
        <div class="mt-4" :class="isPrompay && total <= 5000 ? 'dashed-line' : '' ">
            <div class="mt-3">
                <h2>
                    โอนผ่านบัญชีธนาคาร
                </h2>
            </div>
            <div v-for="bank in shopPayment" :key="bank.id" >
                <div class="d-flex align-items-center">
                    <div class="col-7">
                        <div class="row align-items-center">
                            <div class="col-3">
                                <img class="" :src="formatBankImage(bank.account_bank)" width="35" height="35" alt="">
                            </div>
                            <div class="col-9 py-3 name-payment">
                                <p class="m-0">
                                    {{ bank.name }}
                                </p>
                                <p class="m-0 name-bank font-16px">
                                    {{ formatBankName(bank.account_bank) }}
                                </p>
                                <h2 class="m-0 text-line-primary name-id-bank font-16px">
                                    <strong>{{ formatNum(bank.account_id) }}</strong>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 text-right copy-button">
                        <b-button class="non-wrap-text border-copy non-boxshadow" @click="copyAccountId(bank.account_id)">
                            <img src="../../assets/icon/copybank.png" alt="" width="25">
                            <span class="font-16px text-copy">
                                คัดลอก
                            </span>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2 dashed-line howto-pay">
            <p>วิธีการชำระเงิน</p>
            <p class="m-0">
                1.คลิกปุ่ม “คัดลอก”
            </p>
            <p class="m-0">
                2.เปิดแอปพลิเคชันธนาคารเพื่อทำการโอนเงิน
            </p> 
            <p class="m-0">
                3.ส่งหลักฐานการชำระเงินมาที่แชท Line
            </p>
        </div>
    </div>
    <div class="bt-box-absolute">
        <b-button variant="outline-line-primary" class="mt-2 hover-button-primary" block @click="closeTab">กลับสู่ Chat</b-button>
    </div>
    <div v-if="alertToast" class="border-toast toast-fade-in">
        <span class="text-white">{{ messageToast }}</span>
    </div>
  </div>
</template>

<script>
const context_line = JSON.parse(localStorage.getItem('context_line'))
import formatBank from "@/plugins/formatPayment"
import { formatNumberBank } from "@/helpers/util.js"
export default {
    data() {
        return {
            shopPayment:  [],
            total: 0,
            alertToast: false,
            messageToast: '',
        }
    },
    computed: {
        linkURL() {
            const phone = this.getPhoneNumber()
            return `https://promptpay.io/${phone}/${this.total}.png`
        },
        isPrompay() {
            return this.shopPayment.some(payment => payment.account_bank === '999' && payment.status === 'OPEN')
        },
    },
    methods: {
        openToast(text) {
            this.messageToast = text
            this.alertToast = true
            setTimeout(() => {
                this.alertToast = false
            }, 1000)
        },
        sharingQR() {
            const url = this.linkURL
            console.log('this.linkURL = ', url)
            this.$liff.shareTargetPicker([
            {
                type: 'image',
                originalContentUrl: url,
                previewImageUrl: url,
            },
            ])
            .then(() => {
                console.log('Shared successfully')
            })
            .catch((err) => {
                console.error(err)
            })
        },
        getPhoneNumber() {
            const phoneNumber = this.shopPayment.find(payment => payment.account_bank === '999')
            return phoneNumber ? phoneNumber.account_id : ''
        },
        async downloadImage(imageUrl) {
        //     console.log('imageUrl: ', imageUrl)
        //     const response = await fetch(imageUrl);
        //     const blob = await response.blob();
        //     const link = document.createElement("a");
        //     link.href = URL.createObjectURL(blob);
        //     link.download = "image.png";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
            const img = document.createElement('img');
                img.crossOrigin = 'anonymous'; // Set the crossOrigin attribute
                img.src = imageUrl;
                img.onload = function() {
                    const canvas = document.createElement('canvas');
                    canvas.width = this.width;
                    canvas.height = this.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(this, 0, 0);
                    const dataUrl = canvas.toDataURL('image/png');
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'image.png';
                    link.click();
                }
        },
        // async downloadImage(imageUrl) {
        //   // Load the image into an <img> element
        //   const img = document.createElement('img');
        //   img.crossOrigin = 'anonymous'; // Allow cross-origin access
        //   img.src = imageUrl;
        //   await new Promise(resolve => {
        //     img.onload = resolve; // Wait for the image to load
        //   });
        
        //   // Create a <canvas> element and draw the image onto it
        //   const canvas = document.createElement('canvas');
        //   canvas.width = img.naturalWidth;
        //   canvas.height = img.naturalHeight;
        //   const context = canvas.getContext('2d');
        //   context.drawImage(img, 0, 0);
        
        //   // Convert the canvas data to a downloadable PNG file
        //   const dataUrl = canvas.toDataURL('image/png');
        //   const link = document.createElement('a');
        //   link.href = dataUrl;
        //   link.download = 'image.png';
        //   document.body.appendChild(link);
        //   link.click();
        //   document.body.removeChild(link);
        // },
        
        formattedTotal(number) {
          return parseInt(number).toFixed(2)
        },
        copyAccountId(accountId) {
            let tempInput = document.createElement("input");        
            tempInput.value = accountId;
            document.body.appendChild(tempInput); 
            tempInput.select();  
            document.execCommand("copy");
            document.body.removeChild(tempInput);  
            this.openToast('คัดลอก')
        },
        formatBankImage(keyCode) {
            const { image } = formatBank.find(res => res.code === keyCode)
            return "../../"+image
        },
        formatBankName(keyCode) {
            return formatBank.find(res => res.code === keyCode).name
        },
        formatNum(num) {
            return formatNumberBank(num)
        },
        async closeTab() {
            await this.$liff.closeWindow();
        },
        getShopBank() {
            const orderId = this.$route.query.orderId
            if(!orderId) {
                alert("ไม่พบร้านค้าที่คุณต้องการ")
            }
            const header = {
                headers: {
                    Token: localStorage.getItem('access_token_customer')
                }
            }
            try {
                this.$http.get(this.$API_URL + `/line/order/${orderId}`, header).then((res)=> {
                    this.shopPayment = res.data.data.shop_bank_details
                    this.total = parseInt(res.data.data.total)
                })
            } catch (e) {
                console.error(e)
            }
        },
    },
    async mounted() {
        await this.$liff.init({
            liffId: context_line.liffId
        })
        this.getShopBank() 
    }
}
</script>